import { render, staticRenderFns } from "./HRegBasic.vue?vue&type=template&id=ef922898&scoped=true"
import script from "./HRegBasic.vue?vue&type=script&lang=js"
export * from "./HRegBasic.vue?vue&type=script&lang=js"
import style0 from "./HRegBasic.vue?vue&type=style&index=0&id=ef922898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef922898",
  null
  
)

export default component.exports